module.exports = __webpack_public_path__ + "static/media/team.d87e0a71.png";